import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/#about", label: "About" },
  { to: "/#expertise", label: "Expertise" },
  { to: "/#stack", label: "Stack" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  const handleAnchor = (e, hash) => {
    if (!onHome) return; // let router navigate
    if (hash?.startsWith("/#")) {
      const id = hash.slice(2);
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <header
      className="sticky top-0 z-40 border-b border-ink-900/10 bg-paper/85 backdrop-blur-md"
      data-testid="site-header"
    >
      <div className="wrap flex h-16 items-center justify-between">
        <Link
          to="/"
          className="group flex items-center gap-2.5"
          data-testid="brand-home-link"
        >
          <span className="flex h-7 w-7 items-center justify-center rounded-sm bg-ink-900 font-mono text-[11px] font-semibold text-paper transition group-hover:bg-clay-600">
            VRH
          </span>
          <span className="display text-[17px] font-medium tracking-tight">
            VRH Digital
          </span>
          <span className="hidden font-mono text-[10.5px] uppercase tracking-[0.22em] text-ink-400 sm:inline">
            / Roman Ryzhov
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="primary-nav">
          {navItems.map((item) => {
            const isAnchor = item.to.startsWith("/#");
            if (isAnchor) {
              return (
                <a
                  key={item.to}
                  href={item.to}
                  onClick={(e) => handleAnchor(e, item.to)}
                  className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-700 transition hover:text-clay-600"
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </a>
              );
            }
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `font-mono text-[11px] uppercase tracking-[0.22em] transition hover:text-clay-600 ${
                    isActive ? "text-clay-600" : "text-ink-700"
                  }`
                }
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        <Link
          to="/contact"
          className="hidden rounded-full border border-ink-900/15 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.22em] text-ink-900 transition hover:border-ink-900 hover:bg-ink-900 hover:text-paper md:inline-block"
          data-testid="header-cta-contact"
        >
          Start a project →
        </Link>
      </div>
    </header>
  );
}
